import React from 'react';
import { HiOutlineMenuAlt4, HiOutlineSearch, HiX } from 'react-icons/hi';
import { HashLink } from 'react-router-hash-link';
import { headerData } from '../../../data/headerData';
import ChangeTheme from '../../helper/change-theme/change-theme';
import { OPEN_PALETTE_EVENT, shortcutLabel } from '../command-palette/command-palette';
import './navbar.css';

function NavbarUI({ links, active, open, scrolled, toggleMenu, closeMenu }) {
    const initials = headerData.name
        .split(' ')
        .map((part) => part[0])
        .join('');

    return (
        <header className={`navbar${scrolled || open ? ' navbar--solid' : ''}`}>
            <div className='navbar__bar container'>
                <HashLink to='/#top' className='navbar__brand' onClick={closeMenu}>
                    <span className='navbar__mark' aria-hidden='true'>{initials}</span>
                    <span className='navbar__name'>{headerData.name}</span>
                </HashLink>

                <nav className='navbar__links' aria-label='Primary'>
                    <ul>
                        {links.map(({ id, label }) => (
                            <li key={id}>
                                <HashLink
                                    to={`/#${id}`}
                                    className={`navbar__link${active === id ? ' is-active' : ''}`}
                                    aria-current={active === id ? 'true' : undefined}
                                >
                                    {label}
                                </HashLink>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className='navbar__actions'>
                    <button
                        type='button'
                        className='navbar__cmd'
                        onClick={() => window.dispatchEvent(new Event(OPEN_PALETTE_EVENT))}
                        aria-label={`Open command menu, ${shortcutLabel()}`}
                        aria-keyshortcuts='Control+K Meta+K'
                    >
                        <HiOutlineSearch aria-hidden='true' />
                        <kbd aria-hidden='true'>{shortcutLabel()}</kbd>
                    </button>
                    <ChangeTheme />
                    {headerData.resumePdf && (
                        <a
                            className='btn navbar__cta'
                            href={headerData.resumePdf}
                            target='_blank'
                            rel='noreferrer'
                        >
                            Resume
                        </a>
                    )}
                    <button
                        type='button'
                        className='navbar__toggle'
                        onClick={toggleMenu}
                        aria-expanded={open}
                        aria-controls='mobile-menu'
                        aria-label={open ? 'Close menu' : 'Open menu'}
                    >
                        {open ? <HiX aria-hidden='true' /> : <HiOutlineMenuAlt4 aria-hidden='true' />}
                    </button>
                </div>
            </div>

            <nav
                id='mobile-menu'
                className={`navbar__mobile${open ? ' is-open' : ''}`}
                aria-label='Mobile'
                hidden={!open}
            >
                <ul className='container'>
                    {links.map(({ id, label }, index) => (
                        <li key={id}>
                            <HashLink to={`/#${id}`} onClick={closeMenu}>
                                <span className='navbar__index' aria-hidden='true'>0{index + 1}</span>
                                {label}
                            </HashLink>
                        </li>
                    ))}
                    {headerData.resumePdf && (
                        <li>
                            <a href={headerData.resumePdf} target='_blank' rel='noreferrer' onClick={closeMenu}>
                                <span className='navbar__index' aria-hidden='true'>↗</span>
                                Resume
                            </a>
                        </li>
                    )}
                </ul>
            </nav>
        </header>
    );
}

export default NavbarUI;
